import { render } from "./InspecaoSecao1.vue?vue&type=template&id=2421b733&scoped=true&ts=true"
import script from "./InspecaoSecao1.vue?vue&type=script&lang=ts"
export * from "./InspecaoSecao1.vue?vue&type=script&lang=ts"

import "./InspecaoSecao1.vue?vue&type=style&index=0&id=2421b733&scoped=true&lang=css"

import exportComponent from "D:\\RopeSeguros\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2421b733"]])

export default __exports__